import {Control} from "ol/control";
import OLMapController from "../OLMapController";

class ClearSelectionControl extends Control {
    // @ts-ignore
    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options: any) {
        // super(opt_options);
        const options = opt_options || {};
        const button = document.createElement('button');
        button.innerHTML = 'C';
        button.title="Clear Selected Feature"

        const element = document.createElement('div');
        element.className = 'ol-unselectable ol-control';
        element.style.left = "0.5em"
        element.style.top = "6.5em"
        element.appendChild(button);



        super({
            element: element,
            target: options.target,
        });

        button.addEventListener('click', ()=>this.handleClearSelection(options.mapCtrl), false);
    }

    handleClearSelection(mapCtrl: OLMapController) {
        mapCtrl.clearSelectedFeatures();
        // mapCtrl.zoomToFullExtent();
    }
}

export default ClearSelectionControl
